import { lazy } from "react";
import Loadable from "../../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../../constants/enums";
import { BUSINESS_CLAIM } from "../../Business.constants";

const BusinessClaim = Loadable(
  lazy(() =>
    import("./Claim").then(({ Claim }) => ({
      default: Claim,
    }))
  )
);

const BusinessClaimTabs = Loadable(
  lazy(() =>
    import("./BusinessClaimTabs").then(({ BusinessClaimTabs }) => ({
      default: BusinessClaimTabs,
    }))
  )
);
export const ClaimRoutes = [
  {
    path: `${BUSINESS_CLAIM}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessClaim />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/business-policy/:customerId/claims-tab/:customerPolicyId/claims",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessClaimTabs />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/business-policy/:customerId/claims-tab/:customerPolicyId/claims/:claimNumber",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <BusinessClaimTabs />
      </AuthorizedRoute>
    ),
  },
];
